import { memo, FC, useCallback } from 'react';
import { LINKS } from 'constants/constants';
import { useTranslationEditorContext } from 'providers/TranslationEditor';
import { useTranslation } from 'react-i18next';
import PrimaryButton from 'components/ui/PrimaryButton';
import { useRouter } from 'next/router';

import { Container, ButtonWrapper, Title, Subtitle } from './styled';

const EmailSent: FC = () => {
  const router = useRouter();
  const { t } = useTranslation();
  const { getDataAttributes } = useTranslationEditorContext();

  const goToMain = useCallback(() => {
    router.push(LINKS.ROOT);
  }, [router]);

  return (
    <Container>
      <Title {...getDataAttributes('qr.cancelSubscription.emailSent.title')}>
        {t('qr.cancelSubscription.emailSent.title', 'Confirmation required')}
      </Title>
      <Subtitle {...getDataAttributes('qr.cancelSubscription.emailSent.subtitle')}>
        {t('qr.cancelSubscription.emailSent.subtitle', 'We sent the confirmation on your email')}
      </Subtitle>
      <ButtonWrapper>
        <PrimaryButton onClick={goToMain} {...getDataAttributes('qr.cancelSubscription.emailSent.confirmButton')}>
          {t('qr.cancelSubscription.emailSent.confirmButton', 'OK')}
        </PrimaryButton>
      </ButtonWrapper>
    </Container>
  );
};

export default memo(EmailSent);
